/**
 * @summary  Indicates the current edit status.
 */
export enum MacdStatus
{
    None = 0,
    /**
     * @summary  The edit is pending
     */    
    Pending,
    /**
     * @summary  The edit has been approved
     */
    Approved,
    /**
     * @summary  The edit has been rejected
     */
    Rejected,


    //TODO:DIW:Review these:
    
    /**
     * @summary  The pending has been selected
     */
    PendingSelected,

    /**
     * @summary  The approved has been selected
     */
    ApproveSelected,

    /**
     * @summary  The rejected has been selected
     */
    RejectSelected,

    /**
     * @summary  The edit has been selected
     */
    EditedSelected
}